import * as React from "react";
import Section from "../Layout/Section";
import SectionDescription from "../Layout/Section/Description";
import SectionTitle from "../Layout/Section/Title";
import Media from "../Common/Media";
import Link from "../UI/Link";
import * as styles from "./whyitsm.module.css";
import TemplateString from "../Common/TemplateString";

const WhyITSM = ({title, description, image, items}) => {
    return (
        <Section>
            <div className={styles.whyitsm__grid}>
                <div className={styles.whyitsm__title}>
                    <SectionTitle>
                        <TemplateString template={title} />
                    </SectionTitle>
                </div>
                <div className={styles.whyitsm__desc}>
                    <SectionDescription>
                        <TemplateString template={description} />
                    </SectionDescription>
                </div>

                {items.map(({id, title: itemTitle, description: itemDescription, url, icon}) => (
                    <div key={id} className={styles.whyitsm__item}>
                        <div className={styles.whyitsm__itemHeader}>
                            <div className={styles.whyitsm__itemIconWrapper}>
                                <Media media={{content: icon}} className={styles.whyitsm__itemIcon} />
                            </div>
                            <h3 className={styles.whyitsm__itemTitle}>
                                <TemplateString template={itemTitle} />
                            </h3>
                        </div>
                        <p className={styles.whyitsm__itemDesc}>
                            <TemplateString template={itemDescription} />
                        </p>
                        {url && (
                            <Link to={url} withArrow>
                                Подробнее
                            </Link>
                        )}
                    </div>
                ))}
                <div className={styles.whyitsm__imageWrapper}>
                    <Media
                        media={{content: image}}
                        className={styles.whyitsm__image}
                        imageProps={{
                            imgClassName: styles.whyitsm__imageImage,
                        }}
                    />
                </div>
            </div>
        </Section>
    );
};

export default WhyITSM;
